<template>
  <div class="login-wrap">
    <div class="content">
      <img class="logo" src="/static/images/logos.jpg" alt="">
      <!-- <div class="logo"></div> -->
      <!-- <div class="text-logo">用醒市，有价值</div> -->
      <div class="form-wrap" style="width: 500px;">
        <div class="section">
          <div class="register">
              <div class="title">填写账户信息</div>
              <div class="form">
                  <div class="lable">
                      <label for="name"><span>*</span> 联系人姓名</label>
                      <el-input v-model="username" @input="getUsername" autocomplete="off" placeholder="请输入姓名..."></el-input>
                  </div>
                  <div class="lable">
                      <label for="name"><span>*</span> 登录手机号</label>
                      <el-input v-model="mobile" @input="getMobile" autocomplete="off" placeholder="请输入手机号码..."></el-input>
                  </div>
                  <div class="lable">
                      <label for="name"><span>*</span> 公司名称</label>
                      <el-input v-model="company_name" @input="getCompany_name" autocomplete="off" placeholder="请输入企业名称"></el-input>
                  </div>
                  <div class="lable">
                      <label for="name"><span>*</span> 门店类型</label>
                      <el-select v-model="store_type" @change="getChange" placeholder="请选择门店类型">
                        <el-option
                        v-for="item in options"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                        </el-option>
                    </el-select>
                  </div>
                  <div class="lable">
                      <label for="name"><span>*</span> 主营品牌</label>
                      <el-select v-model="brand_id" @change="getbrand_idChange" placeholder="请选择主营品牌">
                        <el-option
                        v-for="item in brand_ids"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id">
                        </el-option>
                    </el-select>
                  </div>
                  <div class="lable">
                      <label for="name"><span>*</span> 登录密码</label>
                      <el-input v-model="password" @input="getPassword" show-password autocomplete="off" placeholder="请输入登录密码..."></el-input>
                  </div>
                  <div class="lable">
                      <label for="name"><span>*</span> 经营区域</label>
                      <div class="quyu">
                        <el-select v-model="shengvalue" @change="getshengChange" placeholder="请选择省">
                          <el-option
                            v-for="item in sheng"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                          </el-option>
                        </el-select>
                        <el-select v-model="shivalue" @change="getshiChange" placeholder="请选择市区">
                          <el-option
                            v-for="item in shi"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                          </el-option>
                        </el-select>
                      </div>
                      <!-- <el-cascader :options="cityoptions" v-model="selectedOptions" @change="handleChangeData"></el-cascader> -->
                      <!-- <el-cascader
                      :props="props"
                      v-model="selectedOptions"
                      placeholder="请选择行政区域"
                      @change="handleChange"
                    ></el-cascader> -->
                  </div>
                  <div class="submit">
                      <button @click="register" type="primary">注册</button>
                      <button @click="login" type="primary">已有账户，去登录</button>
                  </div>
              </div>
          </div>
        </div>
      </div>
    </div>
    <div class="footer"> Copyright © 2026 新愿景 <a href="" target="_blank"></a>
    </div>
  </div>
</template>

<script>
  import { register, barnd, getCityList } from "@/api";
  // import city from "../../static/js/country-level2-data";
  export default {
    data() {
      return {
        username: "",
        mobile: '',
        company_name: '',
        options: [
            {
                value: '1',
                label: '门店'
            },
            {
                value: '2',
                label: '通讯城'
            },
            {
                value: '3',
                label: '国包商'
            }
        ],
        store_type: '',
        // 主营品牌
        brand_ids: [],
        brand_id: '',
        city: [],
        password: "",
        // 经营区域
        selectedOptions: [], //存放默认值
        cityoptions: '', //存放城市数据也就是显示出来
        shengvalue: '', // 省值
        shivalue: '', // 市区值
        sheng: [], // 省数据
        shi: [], // 市数据
        radio: '0' // 申请状态:0=申请中,1=已通过,2=拒绝
      };
    },
    
    // 方法
    methods: {
        // 姓名
        getUsername(val){
            // console.log(val)
        },

        // 手机号
        getMobile(val){
            // console.log(val)
        },

        // 公司名称
        getCompany_name(val){
            // console.log(val)
        },

        // 登录密码
        getPassword(val){
            // console.log(val)
        },

        // 门店类型
        getChange(val){
            // console.log(val)
            this.store_type = val
        },

        // 供应商经营选择 品牌
        barndPost() {
            // this.loading = true;
            barnd({}).then((res) => {
                // console.log(res);
                // this.loading = false;
                if (res.data.code == 1) {
                    this.brand_ids = res.data.data
                }
            });
        },
        // 品牌选择id
        getbrand_idChange(val){
            // console.log(val)
            this.brand_id = val
        },

        // 经营区域
        handleChangeData(value) {
            this.city = value.join("/");//获取到城市地址
        },
        // 省值
        getshengChange(val){
            // console.log(val)
            this.shengvalue = val;
            this.shivalue = ''; // 避免显示上次选择的市区
            this.getCityListss(this.shengvalue)
        },
        // 市值
        getshiChange(val){
            // console.log(val)
            this.shivalue = val
        },

        // 默认获取省数据
        getCityList(id) {
            // this.loading = true;
            getCityList({
              pid: id
            }).then((res) => {
                console.log(res);
                // this.loading = false;
                if (res.data.code == 1) {
                  this.sheng = res.data.data;
                }
            });
        },
        // 根据省获取市区
        getCityListss(id) {
            // this.loading = true;
            getCityList({
              pid: id
            }).then((res) => {
                // console.log(res);
                // this.loading = false;
                if (res.data.code == 1) {
                  this.shi = res.data.data;
                }
            });
        },

        // 获取省市区街道
        provinceFn(id) { 
          return areaOption(id)
        },

        // 登录
      login(){
        this.$router.replace("/login")
      },

      // 注册
      register () {
        if (this.username === '') {
          this.$message.error('请输入姓名');
          return
        }if (this.mobile === '') {
          this.$message.error('请输入手机号');
          return
        }if (this.company_name === '') {
          this.$message.error('请输入公司名称');
          return
        }if (this.store_type === '') {
          this.$message.error('请选择门店类型');
          return
        }if (this.brand_id === '') {
          this.$message.error('请选择主营品牌');
          return
        }if (this.password === '') {
          this.$message.error('请输入登录密码');
          return
        }if (this.shengvalue === '') {
          this.$message.error('请选择省');
          return
        }if (this.shivalue === '') {
          this.$message.error('请选择市');
          return
        } else {
            register({
                username: this.username,
                mobile: this.mobile,
                company_name: this.company_name,
                store_type: this.store_type,
                brand_id: this.brand_id,
                password: this.password,
                city: this.shengvalue + ',' + this.shivalue,
                radio: this.radio
            }).then(res => {
            console.log(res);
            if (res.data.code == 1) {
            //   res.data.data.id  // 返回申请ID
            //   let token = res.data.data.userinfo.token;
            //   localStorage.setItem("token", JSON.stringify(token));
            //   console.log("login-token",res.data.data.userinfo.token);
              this.$message({
                message: res.data.msg,
                type: 'success'
              });
              this.$router.replace("/login")
            } else {
              this.$message.error(res.data.msg);
            }
          }).catch(error => {
            this.$message.error(res.data.msg);
            console.log(error);
          });
        }
      }
    },
    created() {
        this.barndPost(); // 供应商经营选择
        this.getCityList(); // 经营区域城市
      // this.axios({
      //     method: 'post',
      //     url: 'http://192.168.0.9/api/user/login',
      //     data: {}
      // })
      // .then((res) => {
      //   console.log(res);
      // });
    },
  };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.login-wrap{
    height: 100vh;
    width: 100%;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -ms-flex-direction: column;
    flex-direction: column;
}
.login-wrap .content {
    -webkit-box-flex: 1;
    -ms-flex: 1;
    flex: 1;
    position: relative;
    width: 100%;
    background-image: url(../../static/images/bg.png);
    background-size: cover;
    --rightWid: 7.8%;
}
.login-wrap .content .logo {
    background-image: url(../../static/images/logos.jpg);
    position: absolute;
    top: 48px;
    left: 64px;
    /* width: 201.37px; */
    height: 100px;
    background-size: contain;
}
.login-wrap .content .text-logo {
    position: absolute;
    width: 540px;
    top: 70%;
    right: calc(700px + var(--rightWid));
    font-size: 48px;
    text-align: end;
    font-weight: 700;
    color: #fff;
}
.login-wrap .content .form-wrap, .login-wrap .content .section {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
}
.login-wrap .content .form-wrap {
    position: absolute;
    top: 50%;
    -webkit-transform: translateY(-50%);
    transform: translateY(-50%);
    padding: 24px 12px 24px 36px;
    right: var(--rightWid);
    width: 530px;
    height: calc(100% - 130px);
    -ms-flex-direction: column;
    flex-direction: column;
    -webkit-box-align: start;
    -ms-flex-align: start;
    align-items: flex-start;
    background: #fff;
    -webkit-box-shadow: 2px 4px 28px 1px rgba(0, 0, 0, .04), 2px 4px 18px 1px rgba(0, 0, 0, .08), 2px 4px 8px 1px rgba(0, 0, 0, .1);
    box-shadow: 2px 4px 28px 1px rgba(0, 0, 0, .04), 2px 4px 18px 1px rgba(0, 0, 0, .08), 2px 4px 8px 1px rgba(0, 0, 0, .1);
    border-radius: 12px 12px 12px 12px;
    opacity: 1;
    border: 2px solid #fff;
}
.login-wrap .content .section {
    -webkit-box-flex: 1;
    -ms-flex: 1;
    flex: 1;
    -ms-flex-direction: column;
    flex-direction: column;
    padding-right: 24px;
    overflow-y: auto;
    overflow-x: hidden;
    width: 100%;
    -ms-overflow-style: scrollbar;
    scrollbar-gutter: stable;
}
.qrcode-content {
    margin: auto;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -ms-flex-direction: column;
    flex-direction: column;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
}
.qrcode-content .title{
    height: 39px;
    font-size: 28px;
    font-weight: 700;
    color: #333;
}
.qrcode-content .descrript {
    margin-top: 12px;
    height: 25px;
    font-size: 18px;
    font-weight: 700;
    color: #333;
}
.qrcode-content .descrript span {
    font-size: 18px;
    color: #1dc11d;
}
.qrcode-content .code {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    margin-top: 24px;
    border-radius: 0;
    opacity: 1;
    width: 250px;
    height: 250px;
}
.qrcode-content .code img {
    width: 250px;
    height: 250px;
}
.footer {
    background: #999;
    text-align: center;
    font-size: 14px;
    line-height: 52px;
    font-weight: 400;
    color: #fff;
}
.register .title{
    font-size: 18px;
    line-height: 1;
    font-weight: 400;
    color: #333;
    text-align: center;
    margin: 25px 0;
}
.lable{
    margin-bottom: 16px;
}
.lable .quyu{
  display: flex;
  align-items: center;
  gap: 15px;
}
.lable label{
    font-size: 14px;
    color: #606266;
    margin-bottom: 6px;
    display: flex;
    align-items: flex-end;
    font-weight: bold;
}
.lable label span{
    color: #ff4949;
    margin-right: 4px;
}
.register .el-select, .register .el-cascader{
    width: 100%;
}
.submit button{
    width: 100%;
    height: 46px;
    -webkit-box-shadow: 2px 2px 18px 1px rgba(0,0,0,.08);
    box-shadow: 2px 2px 18px 1px rgba(0,0,0,.08);
    border-radius: 3px 3px 3px 3px;
    font-size: 16px;
    font-weight: 700;
    color: #fff;
    background-color: #409EFF;
    border-color: #409EFF;
    outline: none;
    border: 0;
    cursor: pointer;
}
.submit button:after{
    display: none;
}
.submit button:last-child{
    background: transparent;
    color: #999;
    box-shadow: none;
    line-height: normal;
    height: auto;
    display: block;
    /* justify-content: center; */
    width: auto;
    margin: 20px auto 0;
    font-weight: normal;
}
</style>



// WEBPACK FOOTER //
// src/components/register.vue